import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

@Component({
    selector: 'gl-updates-popup',
    templateUrl: './updates-popup.component.html',
    styleUrls: ['./updates-popup.component.scss'],
    standalone: false
})
export class UpdatesPopupComponent {
  public currentLang: string = this.translate.currentLang;
  constructor(private modalRef: ModalOverlayRef, private translate: TranslateService) {
    this.modalRef.backgroundClicked();
  }

  public close(): void {
    this.modalRef.close();
  }
}
